var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import * as moment from 'moment';
import { Popover } from '@material-ui/core';
import { useDrag } from 'react-dnd';
import { PlayerState, PlaybackManager, PlayerContextConsumer, UserContextConsumer, DropdownMenu, SoundDownloadManager, SoundManager } from '../..';
import { Tooltip } from '../utility';
import { DriveContextConsumer, EditModeContextConsumer, SoundDownloadContextConsumer } from '../../context';
import { CHECKBOX_CHECKED_SVG, STOP_RUBY_SVG, PLAY_WHITE_SVG, PLAY_BLACK_SVG, MIDI_FILL_SVG, MIDI_WHITE_SVG, RINGS_SVG, FAV_FILLED_SVG, FAV_SVG, DOWNLOAD_FILLED_SVG, DOWNLOAD_SVG, ELLIPSES_SVG } from '../../assets';
import { WaveForm } from '../WaveForm';
import { DispatchEdit, EditGridSelectKey } from '../edit';
import { BPMSoundsGeneric } from '../../generic';
import SoundTags from './SoundTags';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { Popup } from '..';
import * as toastr from 'toastr';
import { translations } from '../../translations';
import { Collapse } from 'reactstrap/lib';
export function togglePlayPause(playerContext, sound, playList, parentContainer, onlyPlay) {
    if (onlyPlay === void 0) { onlyPlay = false; }
    var mediaSelected = false;
    if (playerContext.media && playerContext.state >= PlayerState.Loading) {
        mediaSelected = playerContext.media.sound.id == sound.id;
    }
    if (mediaSelected && onlyPlay == false) {
        PlaybackManager.getInstance().pause(undefined, true);
        if (parentContainer && !parentContainer.classList.contains('allow-hover')) {
            parentContainer.classList.add('allow-hover');
        }
    }
    else {
        PlaybackManager.getInstance().getContentManager().replaceLists(playList);
        PlaybackManager.getInstance().startTrack(playList.tracks().find(function (a) { return a.sound.id == sound.id; }));
        if (parentContainer && parentContainer.classList.contains('allow-hover')) {
            parentContainer.classList.remove('allow-hover');
        }
    }
}
;
function SoundListItem(props) {
    var sound = props.sound, similar = props.similar, onSoundClick = props.onSoundClick, playList = props.playList, isSimilarList = props.isSimilarList, drive = props.drive, toggleSimilarSound = props.toggleSimilarSound, onSoundLikeToggled = props.onSoundLikeToggled, onSoundReported = props.onSoundReported, refreshList = props.refreshList, parentContainer = props.parentContainer, onSoundDownload = props.onSoundDownload, onBPMClick = props.onBPMClick, onKeyClick = props.onKeyClick, onTagClick = props.onTagClick, renderListItem = props.renderListItem;
    var _a = React.useState(), anchorEl = _a[0], setAnchorEl = _a[1];
    var _b = React.useState(true), allowDrag = _b[0], setAllowDrag = _b[1];
    var _c = useDrag({
        item: { type: 'Sound', sound: sound },
        canDrag: function (monitor) {
            return true;
        },
        collect: function (monitor) { return ({
            opacity: monitor.isDragging() ? 0.5 : 1
        }); },
        begin: function () {
            if (SoundDownloadManager.getInstance().getSounds().length) {
                return { type: 'Sound', sound: SoundDownloadManager.getInstance().getSounds() };
            }
            return { type: 'Sound', sound: sound };
        }
    }), opacity = _c[0].opacity, dragRef = _c[1], connectDragPreview = _c[2];
    connectDragPreview(getEmptyImage(), {
        // IE fallback: specify that we'd rather screenshot the node
        // when it already knows it's being dragged so we can hide it with CSS.
        captureDraggingState: true,
    });
    // ^CHECKBOX
    var renderCheckbox = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("label", { className: "checkbox" },
                React.createElement(SoundDownloadContextConsumer, null, function (value) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement("img", { className: "checkbox-svg " + (value.includes(sound.id) ? '' : 'hidden'), src: CHECKBOX_CHECKED_SVG, alt: "checkbox" }),
                        React.createElement("input", { id: "box", type: "checkbox", checked: value.includes(sound.id), onChange: function () {
                                SoundDownloadManager.getInstance().toggleSound(sound);
                            } })));
                }),
                React.createElement("label", { htmlFor: "checkbox", className: "text prevent-tag-edit-close", onClick: function () {
                        SoundDownloadManager.getInstance().toggleSound(sound);
                    } })));
    };
    // ^ARTWORK
    var renderArtwork = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "artwork-container" },
                React.createElement("img", { className: "artwork", onClick: function () { return onSoundClick(sound); }, src: sound.artwork_url, alt: "album art" }),
                React.createElement(Tooltip, { text: sound.sound_package_name })));
    };
    // ^PLAY BUTTON
    var renderPlayButton = function (sound, playerContext) {
        var mediaSelected = false;
        if (playerContext.media && playerContext.state >= PlayerState.Loading) {
            mediaSelected = playerContext.media.sound.id == sound.id;
        }
        return React.createElement(React.Fragment, null,
            React.createElement(UserContextConsumer, null, function (user) {
                return (React.createElement("div", { className: "play-container", onClick: function () {
                        togglePlayPause(playerContext, sound, playList, parentContainer);
                    } },
                    React.createElement("img", { className: "play-button", src: (function () {
                            if (user.theme === 'black' && mediaSelected) {
                                return STOP_RUBY_SVG;
                            }
                            else if (user.theme === 'black' && !mediaSelected) {
                                return PLAY_WHITE_SVG;
                            }
                            else if (user.theme === 'white' && mediaSelected) {
                                return STOP_RUBY_SVG;
                            }
                            else {
                                return PLAY_BLACK_SVG;
                            }
                        })(), alt: "play/pause button" })));
            }));
    };
    // ^WAVE
    var renderWaveForm = function (sound, playerContext) {
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'wave-form-container', onClick: function () {
                    togglePlayPause(playerContext, sound, playList, parentContainer);
                } },
                React.createElement(WaveForm, { sound: sound, playlist: playList })));
    };
    // ^NAME
    var renderSoundName = function (playerContext) {
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "name", onMouseOver: function () {
                    setAllowDrag(false);
                }, onMouseLeave: function () {
                    setAllowDrag(true);
                }, onClick: function (e) {
                    var _a;
                    if (!((_a = document.getSelection()) === null || _a === void 0 ? void 0 : _a.toString())) {
                        togglePlayPause(playerContext, sound, playList, parentContainer, true);
                    }
                } },
                React.createElement(DispatchEdit, { identifier: "sound:name:" + sound.id, catchOnClick: true, commitChanges: function (name) {
                        return BPMSoundsGeneric.get().updateSound(sound.id, { name: name }).then(function (sound) {
                            SoundManager.getInstance().updateSound(sound);
                        });
                    } }, function (_a) {
                    var containerProps = _a.containerProps, ref = _a.ref;
                    return React.createElement("span", __assign({ ref: ref }, containerProps, { className: "name-inner" }), sound.name);
                })));
    };
    // ^TAGS
    var renderSoundTags = function () {
        return React.createElement(SoundTags, { sound: sound, onTagClick: onTagClick });
    };
    // ^KEY BPM TIME
    var renderKeyBPMTime = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "key-bpm-time-container" },
                React.createElement(SoundDownloadContextConsumer, null, function (value) {
                    return React.createElement(React.Fragment, null,
                        React.createElement(DispatchEdit, { identifier: "sound:key:" + sound.id, commitForIdentifiers: value.map(function (v) { return "sound:key:" + v; }), catchOnClick: true, editRenderer: function (_a) {
                                var ref = _a.ref, dismiss = _a.dismiss, commit = _a.commit;
                                return React.createElement(EditGridSelectKey, { anchor: ref.current, closed: false, onClosed: function () {
                                        dismiss();
                                    }, onKeySelect: function (key) {
                                        commit(key);
                                    }, currentKey: sound.key });
                            }, commitChanges: function (key) {
                                return BPMSoundsGeneric.get().updateSound(sound.id, { key: Boolean(key) ? key : null }).then(function (sound) {
                                    SoundManager.getInstance().updateSound(sound);
                                });
                            } }, function (_a) {
                            var containerProps = _a.containerProps, ref = _a.ref;
                            return React.createElement("span", __assign({ ref: ref, className: "key link", onClick: function () {
                                    sound.key && onKeyClick(sound.key);
                                } }, containerProps), sound.key);
                        }),
                        React.createElement(DispatchEdit, { identifier: "sound:bpm:" + sound.id, commitForIdentifiers: value.map(function (v) { return "sound:bpm:" + v; }), catchOnClick: true, onlyNumbers: true, commitChanges: function (bpm) {
                                return BPMSoundsGeneric.get().updateSound(sound.id, { bpm: bpm }).then(function (sound) {
                                    SoundManager.getInstance().updateSound(sound);
                                });
                            } }, function (_a) {
                            var containerProps = _a.containerProps, ref = _a.ref;
                            return React.createElement("span", __assign({ ref: ref, className: "bpm link", onClick: function () {
                                    sound.bpm && onBPMClick(sound.bpm);
                                } }, containerProps), sound.bpm);
                        }));
                }),
                React.createElement("span", { className: "time" },
                    moment.utc(moment.duration(sound.duration, 'seconds').asMilliseconds()).format('mm:ss'),
                    " ")));
    };
    // ^ICONS
    var renderDownloadMidiIcon = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "download-container " + (sound.midi ? '' : 'hidden') },
                React.createElement("img", { src: sound.midi && sound.midi.downloaded ? MIDI_FILL_SVG : MIDI_WHITE_SVG, alt: "MIDI Icon", className: "midi-icon " + (sound.midi ? ((sound.midi.downloaded ? 'no-fill' : '')) : 'hidden'), onClick: function () {
                        onSoundDownload(sound, true);
                    } }),
                sound.midi && sound.midi.pricing && React.createElement(Tooltip, { text: function () {
                        return React.createElement(React.Fragment, null, "Download MIDI",
                            React.createElement("br", null), "Use " + sound.midi.pricing.value + " Credits");
                    } })));
    };
    var renderHeartIcon = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "heart-container" },
                React.createElement(Tooltip, { text: 'Favorite' }),
                React.createElement("img", { className: "heart-icon " + (sound.is_favorited ? 'no-fill' : ''), src: sound.is_favorited ? FAV_FILLED_SVG : FAV_SVG, alt: "Favorite Icon", onClick: function () {
                        onSoundLikeToggled && onSoundLikeToggled(sound);
                    } })));
    };
    var renderDownloadIcon = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "download-container" },
                React.createElement("img", { src: sound.downloaded ? DOWNLOAD_FILLED_SVG : DOWNLOAD_SVG, alt: "Download Icon", className: "download-icon " + (sound.downloaded ? 'no-fill' : ''), onClick: function () {
                        onSoundDownload(sound);
                    } }),
                sound.midi && sound.midi && sound.pricing ?
                    React.createElement("div", { className: "Tooltip-midi" },
                        React.createElement("span", { className: "divider" }),
                        React.createElement("div", { className: "flex" },
                            React.createElement("img", { className: "midi-pop-icon", src: MIDI_WHITE_SVG, alt: "MIDI Icon" }),
                            React.createElement("span", null, "MIDI FILE AVAILABLE")))
                    : null));
    };
    var renderSimilarIcon = function () {
        var isCurrentSimilar = false;
        if (similar && similar.sound.id == sound.id) {
            isCurrentSimilar = true;
        }
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "rings-container" }, !isSimilarList ?
                React.createElement(React.Fragment, null,
                    React.createElement("img", { src: RINGS_SVG, alt: "Rings Icon", className: "rings-icon " + (isCurrentSimilar ? 'selected' : ''), onClick: function () {
                            toggleSimilarSound(sound);
                        } }),
                    React.createElement(Tooltip, { text: 'Find Similar' }))
                : React.createElement("img", { className: "rings-icon" })));
    };
    var renderEllipsesIcon = function (playerContext) {
        var mediaActive = playerContext.media && playerContext.media.sound.id == sound.id;
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'elipses sound-more-menu ' + (mediaActive ? 'playing' : '') + (anchorEl ? ' open' : ''), onClick: function (event) {
                    setAnchorEl(event.currentTarget);
                } },
                React.createElement("img", { className: "no-fill", src: ELLIPSES_SVG })),
            React.createElement(Popover, { open: Boolean(anchorEl), anchorEl: anchorEl, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { horizontal: 'right', vertical: 'top' } },
                React.createElement(SoundDownloadContextConsumer, null, function (selectedSounds) {
                    return React.createElement(EditModeContextConsumer, null, function (editMode) {
                        return React.createElement(DriveContextConsumer, null, function (drives) {
                            return React.createElement(DropdownMenu, { onRequestClose: function () {
                                    setAnchorEl(undefined);
                                }, reverse: true, menuItems: [
                                    {
                                        text: 'Download',
                                        onClick: function () {
                                            onSoundDownload(sound);
                                        }
                                    },
                                    sound.midi
                                        ? {
                                            text: 'Download MIDI',
                                            onClick: function () {
                                                onSoundDownload(sound, true);
                                            }
                                        }
                                        : undefined,
                                    // "drive" was destructured at the top of RenderList
                                    drive && drive.name ?
                                        {
                                            text: "Remove from " + (drive && drive.name),
                                            onClick: function () {
                                                if (drive) {
                                                    BPMSoundsGeneric.get().driveManager.removeFromDrive(drive.id, sound.id).then(function () {
                                                        refreshList();
                                                    });
                                                }
                                            }
                                        }
                                        // == ELSE IF drives, show add to drive == 
                                        :
                                            drives.length > 0 ?
                                                {
                                                    text: "Add To " + translations.Drive,
                                                    subItems: drives.map(function (drive) {
                                                        return {
                                                            text: drive.name,
                                                            onClick: function () {
                                                                BPMSoundsGeneric.get().driveManager.addSoundToDrive(sound, drive);
                                                            }
                                                        };
                                                    })
                                                }
                                                // == ELSE hide add to drive == 
                                                : undefined,
                                    {
                                        text: sound.is_favorited ? 'Unfavorite' : 'Favorite',
                                        onClick: function () {
                                            onSoundLikeToggled && onSoundLikeToggled(sound);
                                        }
                                    },
                                    onSoundReported ? {
                                        text: 'Report',
                                        onClick: function () {
                                            return Popup.reportSound(sound.name).then(function (action) {
                                                if (action === 'ok') {
                                                    onSoundReported(sound).then(function () {
                                                        toastr.success('Report successful! A member of the BPM team will take a closer look at this sound.');
                                                    });
                                                }
                                            });
                                        }
                                    } : undefined,
                                    editMode ? {
                                        text: 'Replace File',
                                        onClick: function () {
                                            var input = document.createElement('input');
                                            input.type = 'file';
                                            input.onchange = (function (e) {
                                                if (e.target.files && e.target.files.length) {
                                                    var file = e.target.files.item(0);
                                                    var toast_1 = toastr.info('Uploading Sound...', '', { timeOut: 0, extendedTimeOut: 0 });
                                                    BPMSoundsGeneric.get().updateSound(sound.id, { file: file, sound_package_id: sound.sound_package_id }).then(function () {
                                                        toast_1.hide();
                                                        setTimeout(function () {
                                                            toastr.success('Sound Replaced!');
                                                            SoundManager.getInstance().updateSound(sound);
                                                        }, 500);
                                                    }).catch(function (err) {
                                                        toast_1.hide();
                                                        toastr.error(err.message);
                                                    });
                                                }
                                            });
                                            input.click();
                                        }
                                    } : undefined,
                                    editMode ? {
                                        text: 'Delete File',
                                        onClick: function () {
                                            if (selectedSounds.length) {
                                                if (confirm('Are you sure you want to delete all selected sounds?')) {
                                                    Promise.all((__spreadArrays(selectedSounds, [sound.id]).unique()).map(function (sound) {
                                                        return BPMSoundsGeneric.get().updateSound(sound, { deleted_at: new Date().toJSON() });
                                                    })).then(function () {
                                                        toastr.success('Sounds Deleted! Please reload.');
                                                    }).catch(function (err) {
                                                        if (err.status == 404) {
                                                            toastr.success('Sounds Deleted! Please reload.');
                                                        }
                                                        else
                                                            toastr.error(err.message);
                                                    });
                                                }
                                            }
                                            else {
                                                if (confirm('Are you sure you want to delete this sound?')) {
                                                    BPMSoundsGeneric.get().updateSound(sound.id, { deleted_at: new Date().toJSON() }).then(function () {
                                                        toastr.success('Sound Deleted! Please reload.');
                                                    }).catch(function (err) {
                                                        if (err.status == 404) {
                                                            toastr.success('Sound Deleted! Please reload.');
                                                        }
                                                        else
                                                            toastr.error(err.message);
                                                    });
                                                }
                                            }
                                        }
                                    } : undefined,
                                ] });
                        });
                    });
                })));
    };
    var renderExpandedItem = function (playerContext) {
        var _a;
        return React.createElement("div", { className: "versions-dropdown" }, (_a = sound.versions) === null || _a === void 0 ? void 0 : _a.map(function (version) {
            return React.createElement("div", { className: "song-version", key: version.id },
                React.createElement("div", { className: "version-text" }, ':' + version.type),
                renderDownloadIcon(),
                renderPlayButton(version, playerContext),
                renderWaveForm(version, playerContext));
        }));
    };
    var defaultRender = {
        renderCheckbox: renderCheckbox,
        renderArtwork: renderArtwork,
        renderPlayButton: renderPlayButton,
        renderSoundName: renderSoundName,
        renderWaveform: renderWaveForm,
        renderSoundTags: renderSoundTags,
        renderKeyBPMTime: renderKeyBPMTime,
        renderDownloadMidiIcon: renderDownloadMidiIcon,
        renderDownloadIcon: renderDownloadIcon,
        renderSimilarIcon: renderSimilarIcon,
        renderHeartIcon: renderHeartIcon,
        renderEllipsesIcon: renderEllipsesIcon,
        renderExpandedItem: renderExpandedItem
    };
    // ^MAIN RENDER
    return React.createElement(PlayerContextConsumer, { key: sound.id }, function (playerContext) {
        var _a;
        var mediaSelected = false;
        if (playerContext.media && playerContext.state >= PlayerState.Loading) {
            mediaSelected = playerContext.media.sound.id == sound.id;
        }
        return React.createElement(React.Fragment, null,
            React.createElement("li", { ref: dragRef, "data-sound-id": props.sound.id, className: "list-item " + (mediaSelected ? 'sound-item-playing' : ''), style: { opacity: opacity }, draggable: allowDrag },
                renderListItem && renderListItem(props, playerContext, defaultRender),
                !renderListItem && React.createElement(React.Fragment, null,
                    renderCheckbox(),
                    renderArtwork(),
                    renderPlayButton(sound, playerContext),
                    renderWaveForm(sound, playerContext),
                    renderSoundName(playerContext),
                    renderSoundTags(),
                    renderKeyBPMTime(),
                    React.createElement("div", { className: "icons-container" },
                        renderDownloadMidiIcon(),
                        renderSimilarIcon(),
                        renderHeartIcon(),
                        renderDownloadIcon(),
                        renderEllipsesIcon(playerContext)))),
            props.onItemExpand ?
                React.createElement(Collapse, { isOpen: ((_a = props.expandedItem) === null || _a === void 0 ? void 0 : _a.id) === sound.id ? true : false }, props.renderExpandedItem ? props.renderExpandedItem(props, playerContext, defaultRender) : renderExpandedItem(playerContext))
                : null);
    });
}
export default SoundListItem;
//# sourceMappingURL=SoundListItem.js.map